import React, { useRef, useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/serviceProviderDashboardStyle.scss";
import {
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Radio,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
} from "@material-ui/core";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import FontIcon from "react-md/lib/FontIcons";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import OptionsIcon from "react-md-icon/dist/RoundMoreVert";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import Button from "react-md/lib/Buttons/Button";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import ServiceProviderDashboardUtils from "../services/ServiceProviderDashboardUtils";

function ServiceProviderDashboard(props) {
  const [serviceProviderList, setServiceProviderList] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [componentMounted, setComponentMounted] = useState(false);
  const serviceProviderDashboardUtils = new ServiceProviderDashboardUtils();
  const [patientId, setPatientId] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [filterObj, setFilterObj] = useState({
    pageNum: 1,
    pageSize: 30,
    serviceTypeIds: [],
    serviceSubtypeIds: [],
  });
  const [onlyPageChange, setOnlyPageChange] = useState(false);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [serviceSubTypeSelectedOptions, setServiceSubTypeSelectedOptions] =
    useState([]);
  const [serviceSubTypeOptions, setServiceSubTypeOptions] = useState([]);
  const [serviceProviderIdFilterText, setServiceProviderIdFilterText] =
    useState("");

  const handleClick = (event, appointment) => {
    setAnchorEl(event.currentTarget);
    setMenuFor(appointment);
  };
  const [noServiceProvider, setNoServiceProvider] = useState(true);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [numFrom, setNumFrom] = useState(0);
  const [numTo, setNumTo] = useState(0);
  const [serviceProviderNameOptions, setServiceProviderNameOptions] = useState(
    [],
  );
  const [
    filterServiceProviderNameOptions,
    setFilterServiceProviderNameOptions,
  ] = useState([]);
  const [serviceProviderCityOptions, setServiceProviderCityOptions] = useState(
    [],
  );
  const [
    filterServiceProviderCityOptions,
    setFilterServiceProviderCityOptions,
  ] = useState([]);
  const [serviceProviderLocalityOptions, setServiceProviderLocalityOptions] =
    useState([]);
  const [
    filterServiceProviderLocalityOptions,
    setFilterServiceProviderLocalityOptions,
  ] = useState([]);
  const [serviceProviderGroupOptions, setServiceProviderGroupOptions] =
    useState([]);
  const [
    filterServiceProviderGroupOptions,
    setFilterServiceProviderGroupOptions,
  ] = useState([]);
  const [creationDateRangeFilterValueFrom, setCreationDateRangeFilterFrom] =
    useState(null);
  const [creationDateRangeFilterValueTo, setCreationDateRangeFilterTo] =
    useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openFilter, setOpenFilter] = useState(0);
  const [selectedServiceType, setSelectedServiceType] = useState("all");
  const [maxDate, setMaxDate] = useState("");
  const skip = useRef(30);

  useEffect(() => {
    handleGetAllServiceProviders();
    setComponentMounted(true);
    getServiceTypes();
    handleFetchServiceProviderNameOpt("");
    handleFetchServiceProviderCityOpt("");
    handleFetchServiceProviderGroupOpt();
    handleFetchServiceProviderLocalityOpt("");
  }, []);

  useEffect(() => {
    if (componentMounted && onlyPageChange == true) {
      setFilterObj({ ...filterObj, pageNum: pageNum });
    }
  }, [onlyPageChange]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  useEffect(() => {
    if (componentMounted) {
      skip.current = 30;
      handleGetAllServiceProviders();
    }
  }, [filterObj]);

  useEffect(() => {
    if (
      creationDateRangeFilterValueFrom &&
      creationDateRangeFilterValueTo &&
      componentMounted
    ) {
      const from = moment(creationDateRangeFilterValueFrom);
      const to = moment(creationDateRangeFilterValueTo);

      if (from.isAfter(to)) {
        EventService.emit("showError", {
          message: "Error: filter from date is greater than to date",
        });
      }
    }
  }, [creationDateRangeFilterValueFrom, creationDateRangeFilterValueTo]);

  useEffect(() => {
    setFilterObj({
      ...filterObj,
      pageNum: 1,
      nameMatch: filterServiceProviderNameOptions.map((e) => {
        return e.serviceTypeId == 5
          ? e?.dentalInfo?.identityDetails?.name
          : e.serviceTypeId == 4
            ? e?.gymInfo?.identityDetails?.name
            : e.serviceTypeId == 3
              ? e?.vaccineInfo?.identityDetails?.name
              : e.serviceTypeId == 2
                ? e?.checkupInfo?.identityDetails?.name
                : e.serviceTypeId == 1
                  ? e?.consultationInfo?.identityDetails?.name
                  : "";
      }),
    });
    setPageNum(1);
  }, [filterServiceProviderNameOptions]);
  useEffect(() => {
    setFilterObj({
      ...filterObj,
      pageNum: 1,
      cityMatch: filterServiceProviderCityOptions.map((e) => {
        return e.serviceTypeId == 5
          ? e?.dentalInfo?.address?.city
          : e.serviceTypeId == 4
            ? e?.gymInfo?.address?.city
            : e.serviceTypeId == 3
              ? e?.vaccineInfo?.address?.city
              : e.serviceTypeId == 2
                ? e?.checkupInfo?.address?.city
                : e.serviceTypeId == 1
                  ? e?.consultationInfo?.address?.city
                  : "";
      }),
    });
    setPageNum(1);
  }, [filterServiceProviderCityOptions]);
  useEffect(() => {
    setFilterObj({
      ...filterObj,
      pageNum: 1,
      landmarkMatch: filterServiceProviderLocalityOptions.map((e) => {
        return e.serviceTypeId == 5
          ? e?.dentalInfo?.address?.landmark
          : e.serviceTypeId == 4
            ? e?.gymInfo?.address?.landmark
            : e.serviceTypeId == 3
              ? e?.vaccineInfo?.address?.landmark
              : e.serviceTypeId == 2
                ? e?.checkupInfo?.address?.landmark
                : e.serviceTypeId == 1
                  ? e?.consultationInfo?.address?.landmark
                  : "";
      }),
    });
    setPageNum(1);
  }, [filterServiceProviderLocalityOptions]);
  useEffect(() => {
    setFilterObj({
      ...filterObj,
      pageNum: 1,
      groupNameMatch: filterServiceProviderGroupOptions.map((e) => e?.name),
    });
    setPageNum(1);
  }, [filterServiceProviderGroupOptions]);

  //-------------
  function filterUniqueByServiceProviderName(arr) {
    const seen = new Map();
    return arr.filter((e) => {
      const name =
        e.serviceTypeId == 5
          ? e?.dentalInfo?.identityDetails?.name
          : e.serviceTypeId == 4
            ? e?.gymInfo?.identityDetails?.name
            : e.serviceTypeId == 3
              ? e?.vaccineInfo?.identityDetails?.name
              : e.serviceTypeId == 2
                ? e?.checkupInfo?.identityDetails?.name
                : e.serviceTypeId == 1
                  ? e?.consultationInfo?.identityDetails?.name
                  : null;

      if (!name || seen.has(name)) return false;

      seen.set(name, true);
      return true;
    });
  }
  function filterUniqueByServiceProviderCity(arr) {
    const seen = new Map();
    return arr.filter((e) => {
      const name =
        e.serviceTypeId == 5
          ? e?.dentalInfo?.address?.city
          : e.serviceTypeId == 4
            ? e?.gymInfo?.address?.city
            : e.serviceTypeId == 3
              ? e?.vaccineInfo?.address?.city
              : e.serviceTypeId == 2
                ? e?.checkupInfo?.address?.city
                : e.serviceTypeId == 1
                  ? e?.consultationInfo?.address?.city
                  : null;

      if (!name || seen.has(name)) return false;

      seen.set(name, true);
      return true;
    });
  }
  function filterUniqueByServiceProviderLocality(arr) {
    const seen = new Map();
    return arr.filter((e) => {
      const name =
        e.serviceTypeId == 5
          ? e?.dentalInfo?.address?.landmark
          : e.serviceTypeId == 4
            ? e?.gymInfo?.address?.landmark
            : e.serviceTypeId == 3
              ? e?.vaccineInfo?.address?.landmark
              : e.serviceTypeId == 2
                ? e?.checkupInfo?.address?.landmark
                : e.serviceTypeId == 1
                  ? e?.consultationInfo?.address?.landmark
                  : null;

      if (!name || seen.has(name)) return false;

      seen.set(name, true);
      return true;
    });
  }
  //-------------
  const handleFetchServiceProviderNameOpt = (str) => {
    serviceProviderDashboardUtils.getServiceProvidersByFilter(
      {
        ...filterObj,
        pageNum: 0,
        pageSize: 0,
        nameMatch: [],
        name: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.providers && res.providers.length > 0) {
          let allList = [];

          allList = res.providers.map((service) => {
            return { ...service };
          });
          allList = filterUniqueByServiceProviderName(allList);
          setServiceProviderNameOptions(allList);
        } else {
          setServiceProviderNameOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoServiceProvider(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const handleFetchServiceProviderCityOpt = (str) => {
    serviceProviderDashboardUtils.getServiceProvidersByFilter(
      {
        ...filterObj,
        pageNum: 0,
        pageSize: 0,
        cityMatch: [],
        city: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.providers && res.providers.length > 0) {
          let allList = [];

          allList = res.providers.map((service) => {
            return { ...service };
          });
          allList = filterUniqueByServiceProviderCity(allList);
          setServiceProviderCityOptions(allList);
        } else {
          setServiceProviderCityOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoServiceProvider(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const handleFetchServiceProviderGroupOpt = async () => {
    const groupVendorServiceTypeIds = [1, 2, 3, 5];
    try {
      const responses = await Promise.all(
        groupVendorServiceTypeIds.map(
          (id) =>
            new Promise((resolve, reject) => {
              serviceProviderDashboardUtils.getGroupVendorsByFilter(
                { serviceTypeId: id, status: true },
                (res) => resolve(res || []),
                (err) => reject(err),
              );
            }),
        ),
      );
      const seen = new Map();
      const unique = responses.flat().filter((vendor) => {
        if (!vendor?.name || seen.has(vendor.name)) return false;
        seen.set(vendor.name, true);
        return true;
      });
      setServiceProviderGroupOptions(unique);
    } catch (err) {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    }
  };
  const handleFetchServiceProviderLocalityOpt = (str) => {
    serviceProviderDashboardUtils.getServiceProvidersByFilter(
      {
        ...filterObj,
        pageNum: 0,
        pageSize: 0,
        landmarkMatch: [],
        landmark: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.providers && res.providers.length > 0) {
          let allList = [];

          allList = res.providers.map((service) => {
            return { ...service };
          });
          allList = filterUniqueByServiceProviderLocality(allList);
          setServiceProviderLocalityOptions(allList);
        } else {
          setServiceProviderLocalityOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoServiceProvider(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const getServiceTypes = () => {
    let onResponse = (res) => {
      let options = res.map((e) => {
        return { name: e.name, value: e.id };
      });
      setServiceTypeOptions(options);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    serviceProviderDashboardUtils.getServiceType(true, onResponse, onError);
  };

  const getServiceSubTypes = async () => {
    let totalSubTypes = [];

    if (!filterObj.serviceTypeIds || filterObj.serviceTypeIds.length === 0) {
      console.log("No serviceTypeIds found.");
      return;
    }

    try {
      const responses = await Promise.all(
        filterObj.serviceTypeIds.map(
          (id) =>
            new Promise((resolve, reject) => {
              serviceProviderDashboardUtils.getServiceSubType(
                id,
                true,
                (res) => resolve(res),
                (err) => reject(err),
              );
            }),
        ),
      );

      totalSubTypes = responses.flat().map((e) => ({
        name: e.name,
        value: e.id,
      }));
      setServiceSubTypeOptions(totalSubTypes);
    } catch (err) {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    }
  };

  const handleGetAllServiceProviders = (type = 1, btnType = 0) => {
    setServiceProviderList([]);
    setLoading(true);
    serviceProviderDashboardUtils.getServiceProvidersByFilter(
      filterObj,
      (res) => {
        setOnlyPageChange(false);
        if (res && res.providers && res.providers.length > 0) {
          let allList = [];

          allList = res.providers.map((provider) => {
            return { ...provider };
          });
          let localNumFrom, localNumTo;
          if (type === 1) {
            localNumFrom = 1;
            localNumTo = Math.min(30, res.resultCount);
          } else if (type === 2) {
            if (btnType === 0) {
              localNumTo = numFrom - 1;
              localNumFrom = Math.max(numFrom - 30, 1);
            } else {
              localNumFrom = numTo + 1;
              localNumTo = Math.min(numTo + 30, res.resultCount);
            }
          } else if (type === 3) {
            localNumFrom = numFrom;
            localNumTo = numTo;
          }
          setServiceProviderList([...allList]);
          setNoServiceProvider(false);
          setNumFrom(localNumFrom);
          setNumTo(localNumTo);
          setTotalCount(res.totalCount);
          setLoading(false);
        } else {
          setServiceProviderList([]);
          setNoServiceProvider(true);
          setLoading(false);
        }
      },
      (err) => {
        setLoading(false);
        setServiceProviderList([]);
        setNoServiceProvider(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const changeScreen = (ele, opt) => {
    if (opt === 1) {
      props.setView(5, {
        mode: "view",
        serviceProviderId: ele.id,
      });
    } else if (opt === 2) {
      props.setView(5, {
        mode: "update",
        serviceProviderId: ele.id,
      });
    } else if (opt === 3) {
      props.setView(0);
      props.resetDashboardServiceProvider();
    } else if (opt === 4) {
      props.setView(5, {
        mode: "create",
        serviceProviderId: "",
      });
    }
  };

  const handlePrevNextAppoint = (arg) => {
    setOnlyPageChange(true);
    if (arg) {
      setPageNum((prevPage) => prevPage + 1);
    } else {
      if (pageNum > 1) {
        setPageNum((prevPage) => (prevPage > 1 ? prevPage - 1 : 1));
      }
    }
  };

  useEffect(() => {
    if (!patientId && !appointmentId && !phoneNumber && componentMounted) {
      handleGetAllServiceProviders();
    }
  }, [patientId, appointmentId, phoneNumber]);

  const handleChangeServiceType = (event) => {
    setSelectedServiceType(event.target.value);
    if (event.target.value == "" || event.target.value == "all") {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceTypeIds: [],
      });
      setPageNum(1);
    } else {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceTypeIds: [Number(event.target.value)],
      });
      setPageNum(1);
    }
  };

  return (
    <div className="service-provider-dashboard-table-container">
      <div className="navigo-appoint-container">
        <div className="navigo-appoint-section-3">
          <div
            className="navigo-appoint-section-1"
            onClick={() => {
              changeScreen(null, 3);
            }}
          >
            <FontIcon
              id="back_button"
              style={{ fontSize: "36px", marginTop: "8px" }}
            >
              arrow_back
            </FontIcon>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h1 className="navigo-appoint-section-2">Service provider</h1>
            <div style={{ marginLeft: "30px" }} id="search_provider">
              <FormControl variant="outlined" style={{ width: "250px" }}>
                <InputLabel htmlFor="outlined-age-native-simple">
                  Search via service type
                </InputLabel>
                <Select
                  native
                  value={selectedServiceType}
                  onChange={(e) => {
                    handleChangeServiceType(e);
                    e.target.blur();
                  }}
                  label="Search via service type"
                  inputProps={{
                    name: "age",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option value="all">Show all</option>
                  {serviceTypeOptions.map((e) => {
                    return <option value={e.value}>{e.name}</option>;
                  })}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="navigo-appoint-section-4-bottom-button-container">
            <button
              id="add_new_provider"
              className="navigo-appoint-section-4-bottom-button"
              onClick={() => {
                changeScreen(null, 4);
              }}
            >
              Add new
            </button>
          </div>
        </div>

        <div className="navigo-appoint-section-5">
          <div className="navigo-appoint-section-5-grid-container">
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Service <br /> provider Id
              </p>
              <img
                src={filterObj?.Ids?.length > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-service-providerId">
                  <TextField
                    id="appointment-dialog-client-code-filter-service-providerId"
                    className="appointment-dialog-client-code-filter-class"
                    placeholder="Service ID"
                    value={serviceProviderIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/[^0-9,]/g, ""); // Allow only numbers and commas

                      setServiceProviderIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 20,
                    }}
                    InputProps={{
                      endAdornment: serviceProviderIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setServiceProviderIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.Ids;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (serviceProviderIdFilterText.trim()) {
                        const Ids = serviceProviderIdFilterText
                          .split(",")
                          .map((id) => id.trim())
                          .filter((id) => id !== "" && !isNaN(id))
                          .map(Number);

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          Ids,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section">
              <p>
                Service <br /> subtype
              </p>
              <img
                src={
                  filterObj?.serviceSubtypeIds?.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(3);
                  getServiceSubTypes();
                }}
              />
              {openFilter === 3 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                  <Autocomplete
                    multiple
                    id="appointment-dialog-client-code-filter"
                    className="appointment-dialog-client-code-filter-class"
                    disableCloseOnSelect
                    options={serviceSubTypeOptions}
                    value={serviceSubTypeSelectedOptions}
                    onChange={(event, selectedOptions) => {
                      setServiceSubTypeSelectedOptions(selectedOptions);
                      let filt = selectedOptions.map((e) => e.value);
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        serviceSubtypeIds: filt,
                      });
                      setPageNum(1);
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason == "clear") {
                        setServiceSubTypeSelectedOptions([]);
                      }
                    }}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"Enter the service subtype"}
                      />
                    )}
                  />
                </div>
              )}
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Service <br /> provider name
              </p>
              <img
                src={
                  filterServiceProviderNameOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(7);
                }}
              />
              {openFilter === 7 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                  <Autocomplete
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-provider-name"
                    options={serviceProviderNameOptions}
                    getOptionLabel={(option) => {
                      let res =
                        option.serviceTypeId == 5
                          ? option?.dentalInfo?.identityDetails?.name
                          : option.serviceTypeId == 4
                            ? option?.gymInfo?.identityDetails?.name
                            : option.serviceTypeId == 3
                              ? option?.vaccineInfo?.identityDetails?.name
                              : option.serviceTypeId == 2
                                ? option?.checkupInfo?.identityDetails?.name
                                : option.serviceTypeId == 1
                                  ? option?.consultationInfo?.identityDetails
                                      ?.name
                                  : "";
                      if (!res) {
                        res = "";
                      }
                      return res;
                    }}
                    value={filterServiceProviderNameOptions}
                    onChange={(e, v) => {
                      if (v) {
                        setFilterServiceProviderNameOptions(v);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchServiceProviderNameOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Updated <br />
                on
              </p>
              <img
                src={
                  filterObj?.updatedAt?.from || filterObj?.updatedAt?.to
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(8);
                  // setOpenDateRangeFilter(true);
                }}
              />
              {openFilter === 8 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                  <div className="navigo-appointment-date-range-filter ">
                    <p>From</p>
                    <TextField
                      type="date"
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setCreationDateRangeFilterFrom(v.target.value);
                        }
                      }}
                      value={creationDateRangeFilterValueFrom}
                      inputProps={{ max: maxDate }}
                    ></TextField>
                  </div>
                  <div className="navigo-appointment-date-range-filter ">
                    <p>To</p>
                    <TextField
                      type="date"
                      defaultValue={""}
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setCreationDateRangeFilterTo(v.target.value);
                        }
                      }}
                      inputProps={{ max: maxDate }}
                      value={creationDateRangeFilterValueTo}
                    ></TextField>
                  </div>
                  <Button
                    className=""
                    style={{
                      padding: "3px",
                      margin: "0px 5px",
                      backgroundColor: "#c3c3c3",
                    }}
                    onClick={() => {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        updatedAt: {
                          from: moment(creationDateRangeFilterValueFrom)
                            .utc()
                            .startOf("day")
                            .add(1, "day")
                            .toISOString(),

                          to: moment(creationDateRangeFilterValueTo)
                            .utc()
                            .endOf("day")
                            .add(1, "day")
                            .toISOString(),
                        },
                      });
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    Go
                  </Button>
                  <Button
                    className=""
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.updatedAt;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setCreationDateRangeFilterFrom(null);
                      setCreationDateRangeFilterTo(null);
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    <FontIcon className="">close</FontIcon>
                  </Button>
                </div>
              )}
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>Email Id</p>
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>Locality</p>
              <img
                src={
                  filterServiceProviderLocalityOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(9);
                }}
              />
              {openFilter === 9 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                  <Autocomplete
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-provider-locality"
                    options={serviceProviderLocalityOptions}
                    getOptionLabel={(option) => {
                      let res =
                        option.serviceTypeId == 5
                          ? option?.dentalInfo?.address?.landmark
                          : option.serviceTypeId == 4
                            ? option?.gymInfo?.address?.landmark
                            : option.serviceTypeId == 3
                              ? option?.vaccineInfo?.address?.landmark
                              : option.serviceTypeId == 2
                                ? option?.checkupInfo?.address?.landmark
                                : option.serviceTypeId == 1
                                  ? option?.consultationInfo?.address?.landmark
                                  : "";
                      if (!res) {
                        res = "";
                      }
                      return res;
                    }}
                    value={filterServiceProviderLocalityOptions}
                    onChange={(e, v) => {
                      if (v) {
                        setFilterServiceProviderLocalityOptions(v);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchServiceProviderLocalityOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>City</p>
              <img
                src={
                  filterServiceProviderCityOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(6);
                }}
              />
              {openFilter === 6 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                  <Autocomplete
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-provider-city"
                    options={serviceProviderCityOptions}
                    getOptionLabel={(option) => {
                      let res =
                        option.serviceTypeId == 5
                          ? option?.dentalInfo?.address?.city
                          : option.serviceTypeId == 4
                            ? option?.gymInfo?.address?.city
                            : option.serviceTypeId == 3
                              ? option?.vaccineInfo?.address?.city
                              : option.serviceTypeId == 2
                                ? option?.checkupInfo?.address?.city
                                : option.serviceTypeId == 1
                                  ? option?.consultationInfo?.address?.city
                                  : "";
                      if (!res) {
                        res = "";
                      }
                      return res;
                    }}
                    value={filterServiceProviderCityOptions}
                    onChange={(e, v) => {
                      if (v) {
                        setFilterServiceProviderCityOptions(v);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchServiceProviderCityOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Group <br />
                vendor
              </p>
              <img
                src={
                  filterServiceProviderGroupOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                  <Autocomplete
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-provider-vendor-group"
                    options={serviceProviderGroupOptions}
                    getOptionLabel={(option) => option?.name || ""}
                    value={filterServiceProviderGroupOptions}
                    onChange={(e, v) => {
                      if (v) {
                        setFilterServiceProviderGroupOptions(v);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchServiceProviderGroupOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>Status</p>
              <img
                src={
                  filterObj?.status && filterObj?.status != ""
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(2);
                  // setOpenStatusFilter(true);
                }}
              />
              {openFilter === 2 && (
                <div className="mp-service-dashboard-status-filter">
                  <div>
                    <Radio
                      label="active"
                      checked={
                        filterObj.status
                          ? filterObj.status == "active"
                            ? true
                            : false
                          : false
                      }
                      onClick={() => {
                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          status: "active",
                        });
                        setPageNum(1);
                      }}
                    />
                    <label className="label-radio-btn">Active</label>
                  </div>
                  <div>
                    <Radio
                      label="inactive"
                      checked={
                        filterObj.status
                          ? filterObj.status == "inactive"
                            ? true
                            : false
                          : false
                      }
                      onClick={() => {
                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          status: "inactive",
                        });
                        setPageNum(1);
                      }}
                    />
                    <label className="label-radio-btn">Inactive</label>
                  </div>

                  <Button
                    className="clear-navigo-booked-for"
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.status;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setPageNum(1);
                    }}
                  >
                    Clear
                  </Button>
                </div>
              )}
            </div>
            <div></div>
          </div>
        </div>
        <div className="navigo-appoint-section-6">
          {serviceProviderList && serviceProviderList.length > 0 && (
            <div className="navigo-appoint-bottom-bar">
              <Button
                className="navigo-appoint-bottom-bar-button"
                onClick={() => {
                  handlePrevNextAppoint(0);
                }}
                disabled={pageNum == 1 || loading}
              >
                <FontIcon className="navigo-count-icon">arrow_drop_up</FontIcon>
              </Button>
              <div className="navigo-appoint-bottom-bar-text">
                Showing&nbsp;
                <span
                  style={{
                    color: "#ef7c01",
                  }}
                >
                  {(pageNum - 1) * pageSize + 1}&nbsp;- &nbsp;
                  {totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount}
                </span>
                <span>&nbsp;of&nbsp;</span>
                <span>{` ${totalCount}`}</span>
              </div>
              <Button
                className="navigo-appoint-bottom-bar-button"
                onClick={() => {
                  handlePrevNextAppoint(1);
                }}
                disabled={
                  loading ||
                  pageNum * pageSize > totalCount ||
                  (totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount) == totalCount
                }
              >
                <FontIcon className="navigo-count-icon">
                  arrow_drop_down
                </FontIcon>
              </Button>
            </div>
          )}
          <div className="navigo-appoint-section-6-list">
            {serviceProviderList &&
              serviceProviderList.map((ele) => {
                return (
                  <div
                    className="navigo-appoint-section-6-grid-container"
                    key={ele.id}
                  >
                    <div className="general-font-class">{`${ele.id}`}</div>

                    {/* <div className="general-font-class ">
                      {ele.serviceTypeName}
                    </div> */}
                    <div className="general-font-class ">
                      {ele.serviceSubtypeId === 0
                        ? "NA"
                        : ele.serviceSubtypeName}
                    </div>
                    <div className="general-font-class ">
                      {ele.serviceTypeId == 5
                        ? ele?.dentalInfo?.identityDetails?.name
                        : ele.serviceTypeId == 4
                          ? ele?.gymInfo?.identityDetails?.name
                          : ele.serviceTypeId == 3
                            ? ele?.vaccineInfo?.identityDetails?.name
                            : ele.serviceTypeId == 2
                              ? ele?.checkupInfo?.identityDetails?.name
                              : ele.serviceTypeId == 1
                                ? ele?.consultationInfo?.identityDetails?.name
                                : "-"}
                    </div>
                    <div className="general-font-class">
                      {moment.utc(ele.updatedAt).format("DD MMM YYYY")}
                    </div>
                    <div className="general-font-class ">
                      {ele.serviceTypeId == 5
                        ? ele?.dentalInfo?.contactDetails?.bookingEmailId
                        : ele.serviceTypeId == 4
                          ? ele?.gymInfo?.contactDetails?.bookingEmailId
                          : ele.serviceTypeId == 3
                            ? ele?.vaccineInfo?.contactDetails?.bookingEmailId
                            : ele.serviceTypeId == 2
                              ? ele?.checkupInfo?.contactDetails?.bookingEmailId
                              : ele.serviceTypeId == 1
                                ? ele?.consultationInfo?.contactDetails?.emailId
                                : "-"}
                    </div>
                    <div className="general-font-class">
                      {ele.serviceTypeId == 5
                        ? ele?.dentalInfo?.address?.landmark
                        : ele.serviceTypeId == 4
                          ? ele?.gymInfo?.address?.landmark
                          : ele.serviceTypeId == 3
                            ? ele?.vaccineInfo?.address?.landmark
                            : ele.serviceTypeId == 2
                              ? ele?.checkupInfo?.address?.landmark
                              : ele.serviceTypeId == 1
                                ? ele?.consultationInfo?.address?.landmark
                                : "-"}
                    </div>
                    <div className="general-font-class">
                      {ele.serviceTypeId == 5
                        ? ele?.dentalInfo?.address?.city
                        : ele.serviceTypeId == 4
                          ? ele?.gymInfo?.address?.city
                          : ele.serviceTypeId == 3
                            ? ele?.vaccineInfo?.address?.city
                            : ele.serviceTypeId == 2
                              ? ele?.checkupInfo?.address?.city
                              : ele.serviceTypeId == 1
                                ? ele?.consultationInfo?.address?.city
                                : "-"}
                    </div>

                    <div className="general-font-class">
                      {ele.serviceTypeId == 5
                        ? ele?.dentalInfo?.vendorGroup?.vendorName
                        : ele.serviceTypeId == 3
                          ? ele?.vaccineInfo?.vendorGroup?.vendorName
                          : ele.serviceTypeId == 2
                            ? ele?.checkupInfo?.vendorGroup?.vendorName
                            : ele.serviceTypeId == 1
                              ? ele?.consultationInfo?.vendorGroup?.vendorName
                              : "-"}
                    </div>
                    <div className="navigo-appoint-section-6-grid-status">
                      <div
                        className={`${
                          ele.isActive
                            ? "navigo-appoint-non-select-status-active"
                            : "navigo-appoint-non-select-status-inactive"
                        } `}
                      >
                        <span>{ele.isActive ? "Active" : "Inactive"}</span>
                      </div>
                    </div>
                    <IconButton
                      onClick={(e) => handleClick(e, ele)}
                      className="navigo-appoint-section-6-grid-edit-call"
                    >
                      <OptionsIcon />
                    </IconButton>
                  </div>
                );
              })}
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem
                onClick={() => {
                  changeScreen(menuFor, 1);
                  setAnchorEl(null);
                }}
              >
                View service provider
              </MenuItem>

              <MenuItem
                onClick={() => {
                  changeScreen(menuFor, 2);
                  setAnchorEl(null);
                }}
              >
                Edit service provider
              </MenuItem>
            </Menu>
          </div>
          {loading && <GlobalSkeletonLoader />}
          {loading === false && noServiceProvider && (
            <div className="no-appointments-container">
              <p>No service provider found!</p>
            </div>
          )}
        </div>
        {openBackdrop && (
          <div
            className="navigo-appointment-backdrop-class"
            onClick={() => {
              setOpenFilter(0);
              setOpenBackdrop(false);
            }}
          ></div>
        )}
      </div>
    </div>
  );
}

export default ServiceProviderDashboard;
